module.exports = __webpack_public_path__ + "img/a4.3017fe4c.png";